/**
 * Given a SimpleTemplateField type, this hook will extract the field's frame.
 */
import { useMemo } from 'react'

import {
  ConfigurationFieldType,
  isEnumeratedValueFrameFieldValue,
  isRangedValueFrameFieldValue,
  type SimpleTemplateField,
} from '../../types/templateModel'

export const useFieldFrame = (field: SimpleTemplateField) => {
  const frame = useMemo(
    () =>
      field.fieldType === ConfigurationFieldType.SimpleValueSetup
        ? field.value?.frame
        : undefined,
    [field],
  )

  const shouldRenderEnumeratedValueFrame =
    !!frame && isEnumeratedValueFrameFieldValue(frame)

  const shouldRenderRangedValueFrameExpression =
    !!frame && isRangedValueFrameFieldValue(frame)

  const shouldRenderAFrame =
    shouldRenderEnumeratedValueFrame || shouldRenderRangedValueFrameExpression

  return {
    frame,
    shouldRenderEnumeratedValueFrame,
    shouldRenderRangedValueFrameExpression,
    shouldRenderAFrame,
  }
}
